<template>
   <v-container class="d-flex align-center justify-center" style="height: 100vh;">
     <v-card width="600px" class="pa-5 d-flex flex-column align-center">
        <h1 class="text-center indigo--text font-weight-bold">Create an account</h1>
        <v-card-text>
            <v-form ref="loginForm" v-model="validLoginForm">
                <v-text-field
                  v-model="fullName"
                  label="Full Name"
                  dense
                  outlined
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                />
                <v-text-field
                  v-model="email"
                  dense
                  label="Email"
                  outlined
                  clearable
                  color="indigo"
                  :rules="[rules.required, rules.email]"
                />
                <v-text-field
                  v-model="password"
                  label="password"
                  dense
                  outlined
                  color="indigo"
                  :rules="[rules.required]"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                />
                <phoneInput @update="assignPhone" class="mb-4" />
                <v-btn block color="indigo" class="white--text rounded-xl" @click="login" :loading="loading">SignUp</v-btn>
                <div class="text-center">
                  <span>Already have an account?</span>
                  <v-btn text color="indigo" class="ml-n3" to="/login">Login</v-btn>
                </div>
            </v-form>
        </v-card-text>
     </v-card>
   </v-container>
</template>
<script>
import { headersNoAuth } from '.././links'
import phoneInput from '../components/mobile.vue'
export default {
  components: {
    phoneInput
  },
  data () {
    return {
      validLoginForm: true,
      validResetForm: true,
      validResetCodeForm: true,
      loading: false,
      email: null,
      countryIsoCode: null,
      fullName: null,
      phone: null,
      text: null,
      color: null,
      show: false,
      password: null,
      rules: {
        required: value => !!value || 'this field is required',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail'
        }
      }
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate()
      if (this.validLoginForm) {
        this.loading = true
        const body = {
          name: this.fullName,
          password: this.password,
          email: this.email,
          phone: this.phone,
          countryIsoCode: this.countryIsoCode
        }
        const header = { headers: headersNoAuth() }

        this.$http.post('https://www.atnbookingengine.com/api/user/register', body, header)
          .then(response => {
            if (response.data.status) {
              this.$store.commit('showFeedback', { text: response.data.message, color: 'success' })
              this.$store.commit('setEmail', this.email)
              this.$router.push('/verify')
              // localStorage.setItem('token', response.data.data.token.access_token)
            } else {
              this.$store.commit('showFeedback', { text: response.data.message, color: 'error' })
            }
          }).finally(() => {
            this.loading = false
          })
      }
    },
    assignPhone (phone) {
      console.log(phone)
      this.countryIsoCode = phone.countryCode
      this.phone = phone.number
    }

  },
  created () {
  }
}
</script>
